import type { DateFieldType } from './form.types';

export const DATE_FIELD_TYPE_VALUES = ['free', 'present', 'filter', 'reference'] as const satisfies readonly DateFieldType[];

export const DEFAULT_DATE_FIELD_TYPES: readonly DateFieldType[] = ['free'];
